import React, { useEffect, useState } from "react";

// Redux
import { Link, redirect, useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  Label,
  FormFeedback,
  Alert,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";

// import images
import profile from "../../assets/images/profile-img.png";
// import profile from "../../assets/images/logoDitoDark.svg";
import logo from "../../assets/images/logoDitoDark.svg";
import lightlogo from "../../assets/images/logoDitoLight.svg";

//import thunk
import { loginuser, resetLoginMsgFlag } from "slices/auth/login/thunk";

import withRouter from "Components/Common/withRouter";
import { createPublicToken, logOutUser } from "../../helpers/dataBackend";
import { setAuthorization } from "../../helpers/api_helper";
import LanguageDropdown from "Components/Common/LanguageDropdown";
import { useTranslation } from "react-i18next";
import {
  continueRegisterProgress,
  loginUserBackend,
} from "../../helpers/AuthType/authBackend";

const Login = (props: any) => {
  const dispatch: any = useDispatch();

  const [show, setShow] = useState(false);
  const [existingProcess, setExistingProcess] = useState<boolean>(false);
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [emailLogin, setEmailLogin] = useState<string>("");
  //meta title
  document.title = "Login ";
  const { t } = useTranslation();

  const navigate = useNavigate();
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [error, setError] = useState<any>();

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .matches(emailRegex, "Por favor, ingresa un email válido")
        .required("Por favor, ingresa tu email"),
      password: Yup.string().required("Por favor, ingresa tu contraseña"),
    }),
    onSubmit: async (values: any) => {
      try {
        setEmailLogin(values.email);
        const response = await loginUserBackend({
          email: values.email,
          password: values.password,
        });
        // console.log(response);
        const hasAccess = JSON.parse(response.data);
        if (hasAccess.enabled) {
          dispatch(loginuser(values, props.router.navigate));
        }
        if (hasAccess.enabled === false && hasAccess.type === "UNAUTHORIZED") {
          setTimeout(() => {
            navigate("/no-access-system");
          }, 2000);
        }
        if (hasAccess.type === "INVALID_CREDENTIALS") {
          setError("");
          setTimeout(() => {
            setError(response.message);
          }, 1000);
        }
        if (hasAccess.type === "REGISTER_INCOMPLETE") {
          setError("");
          setExistingProcess(true);
          // setTimeout(() => {
          //   // setError(response.message);
          // }, 2000);
        }
      } catch (error: any) {
        setError(error);
        setTimeout(() => {
          setError("");
        }, 2000);
      }
    },
  });

  const validateLocalStorage = () => {
    const token = localStorage.getItem("authUser");
    setAuthorization(token);
    try {
      if (localStorage.getItem("authUser")) {
        logOutUser();
        localStorage.clear();
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const getPublicToken = async () => {
    const responsePublicToken = await createPublicToken();
    // console.log(responsePublicToken);
    localStorage.setItem("publicToken", responsePublicToken.token);
    setAuthorization(responsePublicToken.token); // Guardar el token antes de continuar
  };

  useEffect(() => {
    validateLocalStorage();
    getPublicToken();
    if (error) {
      console.log(error);
      setTimeout(() => {
        dispatch(resetLoginMsgFlag());
        setError("");
      }, 3000);
    }
  }, [dispatch, error]);

  const handleContinueProcess = async () => {
    setBtnDisabled(true);
    try {
      const response = await continueRegisterProgress({
        email: emailLogin,
      });

      const dataParsed = JSON.parse(response.data);
      window.location.href = dataParsed.registerLink; // Redirige al usuario a la URL de continuación del registro
    } catch (error) {
      console.error("Error al continuar:", error);
      setBtnDisabled(false);
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmationModal(false);
  };

  return (
    <React.Fragment>
      <div style={{ position: "absolute", right: "10px", top: "10px" }}>
        <LanguageDropdown />
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          {t("Welcome to DitoBanx !")}
                        </h5>
                        <p>{t("Log in")}</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-center">
                      <img src={profile} alt="" className="img-fluid m-1" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="auth-logo">
                    <div>
                      <Link to="/" className="auth-logo-light">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded bg-light">
                            <img src={lightlogo} alt="" height="34" />
                          </span>
                        </div>
                      </Link>
                      <Link to="/" className="auth-logo-dark">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded bg-light">
                            <img src={logo} alt="" height="34" />
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        // return false;
                      }}
                    >
                      <div className="mb-3">
                        {error ? (
                          <Alert color="danger">
                            {error
                              ? error
                              : "Hubo un error al Iniciar Sesión, intenta nuevamente"}
                          </Alert>
                        ) : null}
                        <Label className="form-label">{t("Email")}</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder={t("Enter Email")}
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">{t("Password")}</Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={show ? "text" : "password"}
                            placeholder={t("Enter Password")}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          <button
                            onClick={() => setShow(!show)}
                            className="btn btn-light "
                            type="button"
                            id="password-addon"
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </button>
                        </div>
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block "
                          type="submit"
                        >
                          {t("Log in")}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />{" "}
                          {t("Forget Password")}
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Don't have an account ?")}{" "}
                  <Link to="/select-type" className="fw-medium text-primary">
                    {" "}
                    {t("Signup now")}{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* MODAL PARA CONTINUAR EL PROCESO */}
      {existingProcess && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>¿No has terminado de registarte?</h2>
            <p style={styles.modalText}>
              Ya existe un registro que no se ha terminado. Seras redirigido a
              la página de para continuar con el registro.
            </p>
            <div style={styles.buttonGroup}>
              <button
                style={styles.confirmButton}
                onClick={handleContinueProcess}
                disabled={btnDisabled}
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de confirmación */}
      {/* {showConfirmationModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h2 style={styles.modalTitle}>¡Correo enviado!</h2>
            <p style={styles.modalText}>
              Hemos enviado un enlace a tu correo electrónico. Ya puedes cerrar
              esta página y continuar el registro con el enlace compartido.
            </p>
            <div style={{ marginTop: "20px" }}>
              <button
                style={styles.confirmButton}
                onClick={handleCloseConfirmation}
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      )} */}
    </React.Fragment>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalBox: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    width: "90%",
    maxWidth: "400px",
    minWidth: "280px",
    textAlign: "center",
  },
  modalTitle: {
    marginBottom: "15px",
    color: "#333",
  },
  modalText: {
    color: "#555",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px",
    gap: "10px",
  },
  cancelButton: {
    flex: 1,
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#e0e0e0",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
  confirmButton: {
    flex: 1,
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#4caf50",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default withRouter(Login);
